import Location from 'react-app-location';

export const PhoneVerifyLocation = new Location('/phone/verify');
